import { ParamMap } from '@angular/router';

export function fromParamMap<T>(
	...fns: ((args: ParamMap) => Partial<T>)[]
): (arg: ParamMap) => Partial<T> {
	return (arg: ParamMap) =>
		fns.reduce(
			(prev: Partial<T>, fn: (arg: ParamMap) => Partial<T>) =>
				fn(arg)
					? {
							...prev,
							...fn(arg),
					  }
					: prev,
			{}
		);
}
